module.exports = __webpack_public_path__ + "static/media/Giddyapp_5.95a60e95.png";